module.exports = __webpack_public_path__ + "img/header.42fcf262.jpg";